import React from "react";
import Service from "./Products";
import detergents from "../../images/services/detergents.png";
import solarPanel from "../../images/services/solar-panel.png";
import cosmetic from "../../images/services/cosmetic.png";
import food from "../../images/services/food.png";
import construction from "../../images/services/construction.png";

function Services() {
  return (
    <React.Fragment>
  <h3 className="text-center">PRODUCTS</h3>
  <div className="  py-4">
    <div className="container " >
    <div class="m-auto row w-100">
    <Service
          image={food}
          title={"Food and Beverages"}
          body={
            <>
      <p>We provide a variety of high-quality food products and beverages tailored to meet consumer needs. Our portfolio includes:</p>
      <ul>
        <li>Processed foods (canned goods, snacks, packaged items).</li>
        <li>Beverages (soft drinks, juices, and mineral water).</li>
        <li>Essential commodities (rice, flour, sugar, spices).</li>
      </ul>
      <p>
        We ensure the highest standards of food safety and quality, sourcing products from trusted suppliers worldwide.
      </p>
    </>     
          }
        />
        <Service
          image={detergents}
          title={"Detergents and Disinfectants"}
          body={
            <>
            <p>We offer a comprehensive range of cleaning and hygiene solutions for both domestic and industrial applications, including:
            </p>
            <ul>
              <li>Household detergents (laundry powders, dishwashing liquids).
              </li>
              <li>Industrial-grade disinfectants for healthcare and business sectors.
              </li>
              <li>Eco-friendly cleaning products for sustainable solutions.
              </li>
            </ul>
            <p>
            Our products are designed to ensure safety, effectiveness, and environmental friendliness.

            </p>
          </> 
          }
        />
        <Service
          image={cosmetic}
          title={"Cosmetic Products"}
          body={
            <>
            <p>We bring high-quality cosmetic and personal care products to meet modern beauty and wellness needs:
            </p>
            <ul>
              <li>Skincare essentials (moisturizers, serums, sunscreen).
              </li>
              <li>Haircare products (shampoos, conditioners, styling gels).
              </li>
              <li>Beauty products (makeup, perfumes, and grooming kits).
              </li>
            </ul>
            <p>
            We collaborate with globally renowned brands to deliver safe and luxurious products.
            </p>
          </> 
          }
        /> 
      </div>
    </div>
  </div>


  {/* <div className=" py-4">
    <div className="container">
    <div class="m-auto row w-100 justify-content-around">

  <Service
          image={construction}
          title={"Building and Construction Materials"}
          body={
            <>
            <p>We support infrastructure projects with reliable and cost-effective building materials, such as:
            </p>
            <ul>
              <li>Cement, steel, and concrete products.
              </li>
              <li>Electrical and plumbing supplies.
              </li>
              <li>Tiles, paints, and finishing materials.
              </li>
            </ul>
            <p>
            Whether it’s small-scale construction or large infrastructure projects, we provide the materials that ensure durability and quality.
            </p>
          </> 
          }
        />
        <Service
          image={solarPanel}
          title={"Solar Energy Equipment"}
          body={
            <>
            <p>As the world transitions to renewable energy, we supply advanced solar solutions for residential, commercial, and industrial applications:
            </p>
            <ul>
              <li>Solar panels and photovoltaic systems.
              </li>
              <li>Solar batteries and inverters.
              </li>
              <li>Solar water heaters and lighting systems.
              </li>
            </ul>
            <p>
            Our products are designed to help customers reduce energy costs and contribute to a sustainable future.
            </p>
          </> 
          }
        />
    </div>
    </div>
  </div> */}
</React.Fragment>

  );
}

export default Services;
